import { ReactNode } from 'react'
import { useTranslation } from 'react-i18next'
import Card from 'ui/atoms/Card/Card'
import UiConfig from 'ui/uiConfig/UiConfig'
import { getMfrrDeliveryWindowEnd } from '../MRFFCMTrading/MFRRCMTrading.helper'

type MFRRMarketResultsProps = {
  dateStartTime: ISODateTime
}

export function MFRRMarketResults({ dateStartTime }: MFRRMarketResultsProps): ReactNode {
  const { t } = useTranslation()
  const dateEndTime = getMfrrDeliveryWindowEnd(dateStartTime)

  return (
    <Card title={t('CM results')}>
      <UiConfig type="mfrr_market_results" datasetStartTime={dateStartTime} datasetEndTime={dateEndTime} />
    </Card>
  )
}
